import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { MenuModel } from '../../Model/Menu/menu.model';

@Injectable({
    providedIn: 'root'
  })
export class MenuDataService {

 private selectedMenuItem = new Subject<MenuModel>();
 currentSelectedMenuItem = this.selectedMenuItem.asObservable();

  constructor() { }

  changeMenu(_selectedMenuItem: MenuModel) {
    this.selectedMenuItem.next(_selectedMenuItem)
  }
}